import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import User from '../views/User.vue'
import Employee from '../views/Employee.vue'
import EmployeeAttendance from '../views/EmployeeAttendance.vue'
import NCP from '../views/NCP.vue'
import NG from '../views/NG.vue'
import Lead from '../views/Lead.vue'





Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/user',
    name: 'User',
    component: User
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee
  },
  {
    path: '/employee_attendance',
    name: 'EmployeeAttendance',
    component: EmployeeAttendance
  },
  {
    path: '/ncp_data',
    name: 'NCP',
    component: NCP
  },
  {
    path: '/ng_data',
    name: 'NG',
    component: NG
  },
  {
    path: '/lead_data',
    name: 'Lead',
    component: Lead
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
